import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { SeasonEntityResources, SeasonEntityResponse } from "~types/seasonEntity";
import type { SeasonEntityTransformed } from "../types/seasonEntityTransformed";

export const useGetSeasonEntity = () => {
  const request = useApi();
  const { organizationId, sport, seasonId, entityId } = useParams();

  return useQuery<SeasonEntityTransformed>({
    queryKey: ["seasonEntity", sport, organizationId, seasonId, entityId],
    queryFn: () =>
      request<SeasonEntityResponse>(
        `${sport}/o/${organizationId}/seasons/entities?seasonIds=${seasonId}&entityIds=${entityId}&include=seasons,entities,conferences,divisions`,
      ).then((response) => {
        const item = response?.data?.[0];
        const resources: SeasonEntityResources | undefined = response?.includes?.resources;

        if (!item) console.warn("Season entity not found", response);

        const seasonEntity: SeasonEntityTransformed = {
          ...item,
          season: resources?.[item.season.resourceType]?.[item.season.id],
          entity: resources?.[item.entity.resourceType]?.[item.entity.id],
          conference: resources?.[item.conference?.resourceType ?? ""]?.[item.conference?.id ?? ""],
          division: resources?.[item.division?.resourceType ?? ""]?.[item.division?.id ?? ""],
        };

        return seasonEntity;
      }),
  });
};
